<!-- eslint-disable vue/html-self-closing -->
<template>
  <section
    v-if="isActive || (optionModel?.type && optionModel?.value)"
    class="gf-custom-search-item"
    :class="{ '--focused': isActive }"
  >
    <div
      class="gf-custom-search-item__type"
      :class="{ '--focused': isTypeCreating }"
    >
      <input
        v-if="isTypeCreating"
        ref="optionTypeInput"
        v-model="optionTypeModel"
        class="gf-custom-search-item__input"
        type="text"
        inputmode="text"
        :maxlength="1"
        autofocus
      />
      <div
        v-if="optionModel?.type"
        class="gf-custom-search-item__card"
      >
        {{ `${optionModel?.type?.title} =` }}
      </div>
      <div
        v-else-if="isActive"
        class="gf-custom-search-item__dropdown"
      >
        <div
          v-for="type in availableOptionTypes"
          :key="type.key"
          class="gf-custom-search-item__option"
          :class="{ '--focused': focusedOptionTypeKey.key === type.key }"
          @mouseover="focusOnTypeOption(type)"
          @mouseleave="resetFocusedOptionTypeKey"
          @click="onOptionTypeClick(type)"
        >
          <i
            class="mr-1"
            :class="type.icon"
          ></i>
          {{ type?.title }}
        </div>
      </div>
    </div>
    <div
      v-if="optionModel?.type"
      class="gf-custom-search-item__value"
      :class="{ '--focused': isValueCreating }"
    >
      <input
        v-if="isValueCreating"
        ref="optionValueInput"
        v-model="optionValueModel"
        class="gf-custom-search-item__input"
        :type="optionModel.type?.type"
        :inputmode="optionModel.type?.type"
      />
      <div
        v-if="optionModel?.value"
        class="gf-custom-search-item__card"
        @click="onValueCardClick"
      >
        <span>{{ optionModel?.value }}</span>
        <button
          type="button"
          class="btn btn-sm"
          @click="deleteOption"
        >
          <i class="gf-icon gf-icon-x gf-fs-1"></i>
        </button>
      </div>
      <div
        v-else-if="isActive && optionValueModel?.length"
        class="gf-custom-search-item__dropdown"
      >
        <div
          class="gf-custom-search-item__option"
          @click="onOptionValueClick(optionValueModel)"
        >
          {{ optionValueModel }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GfCustomSearchItem',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    availableOptionTypes: {
      type: Array,
      default() {
        return [];
      }
    },
    optionIndex: {
      type: Number,
      default: 0
    },
    selectedItem: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      optionModel: {
        type: null,
        value: null
      },
      optionValueModel: null,
      optionTypeModel: null,
      focusedOptionTypeKey: {
        index: null,
        key: null
      }
    };
  },
  computed: {
    isTypeCreating() {
      return !this.optionModel?.type && this.isActive;
    },
    isValueCreating() {
      return !this.isTypeCreating && !this.optionModel?.value;
    }
  },
  watch: {
    isActive() {
      if (this.isActive && this.optionModel.type && this.optionModel.value) {
        this.optionValueModel = this.optionModel.value;
        this.optionModel.value = null;
        this.$nextTick(() => {
          this.focusOnValue();
        });
      }
    },
    selectedItem() {
      this.fillSelectedOption();
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('paste', this.onPaste);
    this.fillSelectedOption();
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('paste', this.onPaste);
  },
  methods: {
    onKeyDown(e) {
      if (this.isActive) {
        switch (e.keyCode) {
          case 8:
            this.onBackspaceClick();
            break;
          case 9:
            e.preventDefault();
            this.onTabClick();
            break;
          case 13:
            e.preventDefault();
            e.stopPropagation();
            this.onEnterClick();
            break;
          case 27:
            this.onEscapeClick();
            break;
          case 38:
            this.onArrowUpClick();
            break;
          case 40:
            this.onArrowDownClick();
            break;
          default:
            this.onAnyKeyDown(e);
            break;
        }
      }
    },
    onBackspaceClick() {
      if (this.isTypeCreating) {
        if (this.optionModel.value?.length > 0) {
          this.deleteOption();
        } else {
          this.$emit('focusOnPrevious');
        }
      } else if (
        this.isValueCreating &&
        (!this.optionValueModel || this.optionValueModel?.length === 0)
      ) {
        this.deleteOption();
        this.$nextTick(() => {
          this.$refs.optionTypeInput.focus();
        });
      }
    },
    onEnterClick() {
      if (this.isTypeCreating && !this.optionModel.type && this.focusedOptionTypeKey?.key) {
        this.optionTypeModel = this.availableOptionTypes[this.focusedOptionTypeKey.index];
        this.onOptionTypeClick(this.optionTypeModel);
      } else if (this.isValueCreating && this.optionValueModel?.length > 0) {
        this.onOptionValueClick(this.optionValueModel);
      }
    },
    onTabClick() {
      if (this.isTypeCreating && !this.optionModel.type) {
        if (
          this.focusedOptionTypeKey.key &&
          this.focusedOptionTypeKey.index < this.availableOptionTypes.length - 1
        ) {
          this.focusOnTypeOption(this.availableOptionTypes[this.focusedOptionTypeKey.index + 1]);
        } else {
          this.focusOnTypeOption(this.availableOptionTypes[0]);
        }
      }
    },
    onEscapeClick() {
      if (this.isTypeCreating) {
        if (this.optionModel.value?.length > 0) {
          this.deleteOption();
        } else {
          this.$emit('unfocus');
        }
      } else if (this.isValueCreating) {
        this.$emit('unfocus');
      }
    },
    onArrowUpClick() {
      if (this.isTypeCreating && !this.optionModel.type) {
        if (this.focusedOptionTypeKey.index === 0) {
          this.focusOnTypeOption(this.availableOptionTypes[this.availableOptionTypes.length - 1]);
        } else if (this.focusedOptionTypeKey.index > 0) {
          this.focusOnTypeOption(this.availableOptionTypes[this.focusedOptionTypeKey.index - 1]);
        } else {
          this.focusOnTypeOption(this.availableOptionTypes[0]);
        }
      }
    },
    onArrowDownClick() {
      if (this.isTypeCreating && !this.optionModel.type) {
        if (
          this.focusedOptionTypeKey.key &&
          this.focusedOptionTypeKey.index < this.availableOptionTypes.length - 1
        ) {
          this.focusOnTypeOption(this.availableOptionTypes[this.focusedOptionTypeKey.index + 1]);
        } else {
          this.focusOnTypeOption(this.availableOptionTypes[0]);
        }
      }
    },
    onAnyKeyDown(e) {
      if (!e.metaKey && !e.altKey && !e.ctrlKey && this.isTypeCreating) {
        this.optionValueModel = this.optionTypeModel;
        this.optionTypeModel = null;
        this.onOptionTypeClick(this.availableOptionTypes[0]);
      }
    },
    onPaste() {
      if (this.isTypeCreating) {
        this.optionValueModel = this.optionTypeModel;
        this.optionTypeModel = null;
        this.onOptionTypeClick(this.availableOptionTypes[0]);
      }
    },
    onOptionTypeClick(type) {
      this.optionModel.type = type;
      if (!this.optionModel.value) {
        this.$nextTick(() => {
          this.focusOnValue();
        });
      }
    },
    onOptionValueClick(value) {
      this.optionModel.value = value;
      this.submitOption();
    },
    onValueCardClick() {
      this.$emit('focusOn', {
        index: this.optionIndex,
        option: this.optionModel
      });
    },
    fillSelectedOption() {
      if (!this.optionModel.type && !this.optionModel.value && this.selectedItem.value) {
        this.optionModel = this.selectedItem;
        this.optionTypeModel = this.selectedItem?.type;
        this.optionValueModel = this.selectedItem?.value;
      }
    },
    focusOnTypeOption(type) {
      this.focusedOptionTypeKey = {
        index: this.availableOptionTypes.indexOf(type),
        key: type.key
      };
    },
    focusOnValue() {
      if (this.$refs.optionValueInput) {
        this.$refs.optionValueInput.focus();
      }
    },
    deleteOption() {
      this.$emit('delete', {
        index: this.optionIndex,
        option: this.optionModel
      });
      this.resetOptionModel();
    },
    resetOptionModel() {
      this.optionModel = {
        type: null,
        value: null
      };
      this.optionTypeModel = null;
      this.optionValueModel = null;
      this.resetFocusedOptionTypeKey();
    },
    resetFocusedOptionTypeKey() {
      this.focusedOptionTypeKey = {
        index: null,
        key: null
      };
    },
    getFocusedOptionTypeKey() {
      return this.focusedOptionTypeKey;
    },
    getOptionInfo() {
      if (!this.optionModel.value) {
        this.optionModel.value = this.optionValueModel;
      }
      return {
        index: this.optionIndex,
        option: this.optionModel
      };
    },
    submitOption() {
      this.$emit('submit', {
        index: this.optionIndex,
        option: this.optionModel
      });
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-custom-search-item';

#{$this} {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  @media screen and (min-width: 768px) {
    flex-wrap: nowrap;
  }

  &.--focused {
    width: 100%;
  }

  #{$this}__type,
  #{$this}__value {
    // min-height: 24px;
    position: relative;
    display: flex;
    gap: 4px;
    z-index: 1;

    &.--focused {
      width: 100%;
    }

    #{$this}__input {
      height: 100%;
      width: 100%;
      color: var(--text);
      padding: 0;
      background-color: transparent;
      border-style: none;
      outline: none;
    }

    #{$this}__card {
      min-height: 34px;
      padding: 3px 8px;
      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 4px;
      overflow: hidden;
      white-space: nowrap;
      background-color: var(--bg-light);
      border-radius: var(--border-radius);

      @include theme.md {
        min-height: 20px;
      }

      & > span {
        max-width: 120px;
        text-wrap: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        @media screen and (min-width: 768px) {
          max-width: 160px;
        }
      }

      & > button {
        min-height: 18px;
        padding: 0;
        color: var(--text-muted);

        &:hover {
          color: var(--text);
        }
        &:focus {
          box-shadow: none !important;
        }
      }
    }

    #{$this}__dropdown {
      width: max-content;
      max-width: 300px;
      position: absolute;
      bottom: -10px;
      left: -9px;
      padding: 12px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      background-color: var(--white);
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius-lg);
      transform: translateY(100%);
      z-index: 1;

      #{$this}__option {
        padding: 4px 8px;
        border-radius: var(--border-radius);
        overflow-wrap: anywhere;
        cursor: pointer;

        &.--focused {
          background-color: var(--bg-light);
        }
      }
    }
  }

  #{$this}__type {
    #{$this}__card {
      cursor: default;
    }
  }
}
</style>
